import { FC } from 'react';
import { CustomerInfoKeyType } from 'types/customer';
import FamilyMember, { FamilyMemberFormutil, FamilyMemberProps } from './FamilyMember';
import MaritalStatus, { MaritalStatusFormutil, MaritalStatusProps } from './MaritalStatus';

export function getFieldsOfFamilyInfo(): CustomerInfoKeyType[] {
    const baseFields: CustomerInfoKeyType[] = ['marital_status', 'family_member'];

    return baseFields;
}

export type FamilyInfoFormutil = FamilyMemberFormutil & MaritalStatusFormutil;

export interface FamilyInfoProps extends FamilyMemberProps, MaritalStatusProps {
    disabled?: boolean;
    familyMemberProps?: FamilyMemberProps;
    maritalStatusProps?: MaritalStatusProps;
    hideTitle?: boolean;
}

const FamilyInfo: FC<FamilyInfoProps> = props => {
    const { disabled, familyMemberProps, maritalStatusProps, hideTitle } = props;
    const { disabled: familyMemberDisabled, ...restFamilyMemberOptions } = familyMemberProps || {};
    const { disabled: maritalStatusDisabled, ...restMaritalStatusOptions } = maritalStatusProps || {};

    return (
        <div>
            {!hideTitle && <h3 className="open-title">{__('FAMILY AND MARITAL STATUS')}</h3>}
            <FamilyMember disabled={familyMemberDisabled || disabled} {...restFamilyMemberOptions} />
            <MaritalStatus disabled={maritalStatusDisabled || disabled} {...restMaritalStatusOptions} />
        </div>
    );
};

export default FamilyInfo;
